import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title:
    "AI-ML driven predictions for \nfallout occurrence during the \norder journey",
  subtitle: "Business Operations Demo",
  text: "Achieving first time completion of the order.",
  label: { iconPath: "start.png", text: "ILO AI" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_111"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_109"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 7_R1.mp4",
  pageNumber: "ILO_110",
};

export default DATA_BO_DEMO_ILO1;
